import React from "react";
import ThumbnailsProduct from "../../../components/ThumbnailsProduct";
import styles from "./MainSection.module.scss";
import { Pagination, Grid } from "semantic-ui-react";

const MainSection = () => {
  const thumbs = [
    {
      url: `https://cdn.pixabay.com/photo/2019/07/07/14/03/fiat-4322521_960_720.jpg`,
      title: "Auto Filipa",
      designer: "Filip",
      price: 90,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/01/21/11/21/pixabay-606618_1280.jpg`,
      title: "Billboard",
      designer: "Bill",
      price: 140,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/12/08/21/42/tools-1083796_1280.jpg`,
      title: "Tools",
      designer: "Tod",
      price: 130,
    },
    {
      url: `https://cdn.pixabay.com/photo/2019/07/07/14/03/fiat-4322521_960_720.jpg`,
      title: "Auto Filipa",
      designer: "Filip",
      price: 90,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/01/21/11/21/pixabay-606618_1280.jpg`,
      title: "Billboard",
      designer: "Bill",
      price: 130,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/12/08/21/42/tools-1083796_1280.jpg`,
      title: "Tools",
      designer: "Tod",
      price: 130,
    },
    {
      url: `https://cdn.pixabay.com/photo/2019/07/07/14/03/fiat-4322521_960_720.jpg`,
      title: "Auto Filipa",
      designer: "Filip",
      price: 190,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/01/21/11/21/pixabay-606618_1280.jpg`,
      title: "Billboard",
      designer: "Bill",
      price: 140,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/12/08/21/42/tools-1083796_1280.jpg`,
      title: "Tools",
      designer: "Tod",
      price: 130,
    },
    {
      url: `https://cdn.pixabay.com/photo/2019/07/07/14/03/fiat-4322521_960_720.jpg`,
      title: "Auto Filipa",
      designer: "Filip",
      price: 90,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/01/21/11/21/pixabay-606618_1280.jpg`,
      title: "Billboard",
      designer: "Bill",
      price: 150,
    },
    {
      url: `https://cdn.pixabay.com/photo/2015/12/08/21/42/tools-1083796_1280.jpg`,
      title: "Tools",
      designer: "Tod",
      price: 130,
    },
  ];

  return (
    <main className={styles.mainSection}>
      <Grid centered>
        {thumbs
          .sort((a, b) => (a.price > b.price ? 1 : -1))
          .map((thumb: any, i: number) => (
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={4}
              key={`${thumb.title}-${i}`}
            >
              <ThumbnailsProduct key={`${thumb.title}-${i}`} thumb={thumb} />
            </Grid.Column>
          ))}
        <aside className={styles.pagination}>
          <Pagination
            defaultActivePage={1}
            firstItem={null}
            lastItem={null}
            pointing
            secondary
            totalPages={3}
          />
        </aside>
      </Grid>
    </main>
  );
};

export default MainSection;
